module.exports = __webpack_public_path__ + "static/img/icon-消息通知.2e285974.png";